import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { HostService } from "./host.service";
import { ToastMessage } from "../toast-message/toast-message.service";

@Component({
  selector: "app-host-search",
  template: require('./host-search.component.html'),
})
export class HostSearchComponent {
  phone = "";
  vehicleNumber = "";
  isLoadingPhone = false;

  constructor(
    private hostService: HostService,
    private router: Router,
    private toast: ToastMessage,
  ) {}

  searchByPhone() {
    if (!this.phone.trim()) {
      this.toast.openSnackBarError("Please enter a phone number");
      return;
    }
    this.isLoadingPhone = true;
    this.hostService.searchByPhone(this.phone.trim()).subscribe(
      (res: any) => {
        this.isLoadingPhone = false;
        const hostId = res && res.hostId;
        if (!hostId) {
          this.toast.openSnackBarError(
            "No host profile found for this phone number",
          );
          return;
        }
        this.router.navigate(["/host", hostId], {
          queryParams: {
            name: res.hostName || "",
            mobile: res.mobile || this.phone.trim(),
          },
        });
      },
      (err) => {
        this.isLoadingPhone = false;
        this.toast.openSnackBarError(
          (err && err.error && err.error.message) || "Failed to search host",
        );
      },
    );
  }

  searchByVehicleNumber() {
    if (!this.vehicleNumber.trim()) {
      this.toast.openSnackBarError("Please enter a vehicle number");
      return;
    }
    this.router.navigate(["/host/rc-results"], {
      queryParams: { number: this.vehicleNumber.trim().toUpperCase() },
    });
  }
}
